import React, { useContext } from "react";
import { useProductSubMenu } from "../hooks/useProductSubMenu";
import { Link } from "gatsby";
import { LangContext } from "../../../context/lang/LangContext";

interface Props {
  handleOpenSubMenu: () => void;
}

export const ProductSubMenuMobile = ({ handleOpenSubMenu }: Props) => {
  const { menuItems, menuSubItems } = useProductSubMenu();

  const { messages } = useContext(LangContext);

  return (
    <div>
      {menuItems.map((item) => (
        <div className="Header__product_mobile_container" key={item.id}>
          <span className="Header__product_mobile_section_name">
            {item.mobileIcon} {item.title}
          </span>
          <div className="Header__product_mobile_subitems_container">
            {menuSubItems
              .filter((subItem) => subItem.menuItemId === item.id)
              .map((subItem, index) => (
                <Link
                  key={index}
                  className="Header__product_mobile_sections_subitem"
                  to={`/${messages.currentLanguage}/product/#${subItem.link}`}
                  onClick={handleOpenSubMenu}
                >
                  {subItem.title}
                </Link>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};
